import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map, Set } from 'immutable';

import { ProjectTraceItemEntity } from './project-trace-item.entity';

export interface IProjectTraceListExtra
	extends IListColumnConfig<ProjectTraceItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface ITraceListEntity extends IListAttrs<ProjectTraceItemEntity> {
	availableColumns: Map<string, IProjectTraceListExtra>;
}

const entityDefaults: ITraceListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class ProjectTraceListEntity
	implements
		ITraceListEntity,
		IListOperations<ProjectTraceListEntity, ProjectTraceItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IProjectTraceListExtra>
	): ProjectTraceListEntity {
		const inst = new ProjectTraceListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IProjectTraceListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<ProjectTraceItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, ProjectTraceItemEntity>
	): ProjectTraceListEntity {
		return produce(this, (draft: ProjectTraceListEntity) => {
			draft.elements = elems;
		});
	}
}
